import { usePunditUserContext } from "@circle-react/contexts";

export const useIsInAppEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.in_app_enabled);
};
